// create a translation provider for vue i18n
// instanciated by a prefix so that there are no conflicts with other providers
// class which provides title, description(or infotext) as separate methods for any FeatureClass


import MetadataBase from "../xmlrdb-metadata/MetadataBase";

export default interface TranslationProvider {
  readonly prefix: string;
  getLabelString(key: string): string;
  // Provide Attribute <Name> of Element <Auslauf> create this Identifier:  <prefix>.Auslauf.Name 
  getLabel(meta: MetadataBase): string;
  getDescriptionString(key: string): string;
  getDescription(meta: MetadataBase): string;
}

let defaultTranslationProvider: TranslationProvider | undefined = undefined;

export function getDefaultTranslationProvider(): TranslationProvider | undefined {
  return defaultTranslationProvider;
}

export function useDefaultTranslationProvider(provider: TranslationProvider) {
  defaultTranslationProvider = provider;
}